import _ from 'underscore';
import PropTypes from 'prop-types';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { TaxFormMode } from './constants';

const { TaxType } = Constants;

const PassiveErrorShape = PropTypes.shape({
  showErrorOnPassiveMessages: PropTypes.bool,
  passiveMessages: PropTypes.arrayOf(PropTypes.string),
});

const MTTaxInfoShape = PropTypes.arrayOf(PropTypes.shape({
  Key: PropTypes.string.isRequired,
  Value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
}));

const TaxInfoShape = PropTypes.shape({
  TaxOptionType: PropTypes.string,
  [TaxType.VATNumber]: PropTypes.string,
  [TaxType.GSTINNumber]: PropTypes.string,
  [TaxType.PANNumber]: PropTypes.string,
  [TaxType.AUGSTNumber]: PropTypes.string,
  [TaxType.NZGSTNumber]: PropTypes.string,
  [TaxType.CPF]: PropTypes.string,
  [TaxType.CCM]: PropTypes.string,
  [TaxType.CNPJ]: PropTypes.string,
  IsStaticTaxOptionType: PropTypes.bool,
  IsTaxExemptionCertVerified: PropTypes.string,
});

const MTTaxCertificationShape = PropTypes.shape({
  TaxCertifications: PropTypes.arrayOf(PropTypes.shape({
    FileGuid: PropTypes.string,
    FileName: PropTypes.string,
  })),
  ReverseChargeDocuments: PropTypes.arrayOf(PropTypes.shape({
    FileGuid: PropTypes.string,
    FileName: PropTypes.string,
  })),
  Status: PropTypes.number,
});

export const TaxCertificationShape = PropTypes.shape({
  taxCertifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    displayName: PropTypes.string,
    file: PropTypes.instanceOf(File),
    guid: PropTypes.string,
    isValid: PropTypes.bool,
  })),
  reverseChargeDocuments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    displayName: PropTypes.string,
    file: PropTypes.instanceOf(File),
    guid: PropTypes.string,
    isValid: PropTypes.bool,
  })),
  status: PropTypes.number,
});

export const MTTaxDataPropTypes = {
  data: MTTaxInfoShape,
  mtData: MTTaxInfoShape,
  taxCertification: MTTaxCertificationShape,
  mtTaxCertification: MTTaxCertificationShape,
};

export const UITaxDataPropTypes = {
  data: TaxInfoShape,
  mtData: TaxInfoShape,
  taxCertification: TaxCertificationShape,
  mtTaxCertification: TaxCertificationShape,
};

const PermissionsPropTypes = PropTypes.shape({
  dynamic: PropTypes.objectOf(PropTypes.bool),
});

const BasePropTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onValidate: PropTypes.func,
  showLineByLineFormGroup: PropTypes.bool,
  taxFormMode: PropTypes.oneOf(_.values(TaxFormMode)),
  disabled: PropTypes.bool,
  alwaysShowError: PropTypes.bool,
  showTaxApprovalForm: PropTypes.bool,
  // ownerAccountId is used for generating accountTaxCertificationLink,
  // which is only required when the taxInfo belongs to some created account.
  ownerAccountId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  urlBuilder: PropTypes.shape({
    UrlBuilders: PropTypes.shape({}),
    UrlHelper: PropTypes.shape({}),
  }),
  showTaxCertLink: PropTypes.bool,
  countries: PropTypes.arrayOf(PropTypes.shape({
    Code: PropTypes.string,
    Name: PropTypes.string,
  })),
  permissions: PermissionsPropTypes,
  isSignupFlow: PropTypes.bool,
  vatStatus: PropTypes.number,
  passiveErrors: PropTypes.shape({
    [TaxType.GSTINNumber]: PassiveErrorShape,
    [TaxType.PANNumber]: PassiveErrorShape,
  }),
  isCPFRequired: PropTypes.bool,
  mtAddress: PropTypes.shape({}),
  accountMode: PropTypes.number,
  isXandrOnboarding: PropTypes.bool,
};

export const AddressTaxFormPropTypes = {
  ...BasePropTypes,
  ...MTTaxDataPropTypes,
  countries: PropTypes.arrayOf(PropTypes.shape({
    Code: PropTypes.string,
    Name: PropTypes.string,
  })).isRequired,
  address: PropTypes.shape({
    Line1: PropTypes.string,
    Line2: PropTypes.string,
    City: PropTypes.string,
    StateOrProvince: PropTypes.string,
    PostalCode: PropTypes.string,
    Country: PropTypes.string,
  }).isRequired,
};

export const TaxFormPropTypes = {
  ...BasePropTypes,
  ...MTTaxDataPropTypes,
  taxFormat: PropTypes.string.isRequired,
};

export const TaxTypeFormPropTypes = {
  ...BasePropTypes,
  ...UITaxDataPropTypes,
};

export const ViewTaxFormPropTypes = {
  ...TaxTypeFormPropTypes,
  filledData: TaxInfoShape,
  taxSchema: PropTypes.shape({}),
};
